import { ARCADE_BADGE_TYPES } from '@/enum'
import ArcadeBadge from '@/components/Badge/ArcadeBadge'
import { numberWithCommas } from '@/util/numberHelpers'
import { determineRank, rankToBadge } from '@/features/arcade/utils'
import { useArcade } from '@/features/arcade/provider'
import { useArcadeSeasonStarts } from '@/features/arcade/hooks/countdown'
import { IButtonProps } from '@/components/Button'
import { Button } from '@/components'

const ARCADE_CTA = 'START'

const useArcadeBadge = () => {
  const { isArcadeLoaded, season, player } = useArcade()
  const { seasonStarts } = useArcadeSeasonStarts({
    season,
    precision: 'medium'
  })

  if (!isArcadeLoaded) return null

  if (seasonStarts.isBefore)
    return { type: ARCADE_BADGE_TYPES.Start, label: seasonStarts.formatted }

  if (!player || player.isNotRanked)
    return { type: ARCADE_BADGE_TYPES.Start, label: ARCADE_CTA }

  return {
    type: rankToBadge[determineRank(player.rank, season.rankThreshold)],
    label: numberWithCommas(player.rank)
  }
}

export const Badge = ({ onClick }: Omit<IButtonProps, 'children'>) => {
  const badge = useArcadeBadge()

  return badge ? (
    <Button theme="clean" onClick={onClick}>
      <ArcadeBadge
        type={badge.type}
        label={
          <span className="h-[20px] inline-block" style={{ lineHeight: 1.5 }}>
            {badge.label}
          </span>
        }
      />
    </Button>
  ) : null
}
